// extracted by mini-css-extract-plugin
module.exports = {"tdStyle":"tdStyle--simpleField--3toIkii","tdText":"tdText--simpleField--3w-8VwV"};